var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "div",
        [
          _c("span", [_vm._v("\n    " + _vm._s(_vm.sqwizPage.label) + "\n  ")]),
          _vm._v(" "),
          _c("span", [_vm._v("\n    (" + _vm._s(_vm.visible) + " objav)\n  ")]),
          _vm._v(" "),
          _c("icon", { attrs: { scale: "1", name: "arrow-right" } }),
          _vm._v(" "),
          _c(
            "input-select",
            _vm._g(
              {
                staticClass: "select-input",
                attrs: {
                  inputName: _vm.sqwizPage.id,
                  transparent: "",
                  variant: "standardInput",
                  inputPlaceholder: "Wordpress",
                  smaller: "",
                  selectOptions: _vm.wordpressUsers
                }
              },
              _vm.$listeners
            )
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-eac2db36", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eac2db36","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/display/migration/sqwiz/Row.vue
// module id = null
// module chunks = 